import { getLanguage } from './i18n';

export const getCurrencyConfig = () => {
  const lang = getLanguage();
  
  if (lang === 'pt-BR') {
    return {
      locale: 'pt-BR',
      currency: 'BRL',
      symbol: 'R$',
      decimalSeparator: ',',
      thousandSeparator: '.',
    };
  }
  
  return {
    locale: 'en-US',
    currency: 'USD',
    symbol: '$',
    decimalSeparator: '.',
    thousandSeparator: ',',
  };
};

export const formatCurrency = (value) => {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(numValue)) {
    return '';
  }
  
  const config = getCurrencyConfig();
  return new Intl.NumberFormat(config.locale, {
    style: 'currency',
    currency: config.currency,
  }).format(numValue);
};

export const parseCurrency = (value) => {
  if (!value || value === '') {
    return '';
  }
  
  const config = getCurrencyConfig();
  let cleaned = value.toString()
    .replace(config.symbol, '')
    .replace(new RegExp('\\' + config.thousandSeparator, 'g'), '')
    .replace(config.decimalSeparator, '.')
    .replace(/\s/g, '')
    .trim();
  
  const parsed = parseFloat(cleaned);
  return isNaN(parsed) ? '' : parsed.toString();
};

export const applyCurrencyMask = (value) => {
  if (!value && value !== 0) {
    return '';
  }
  
  const config = getCurrencyConfig();
  let cleaned = value.toString().replace(/\D/g, '');
  
  if (cleaned === '') {
    return '';
  }
  
  cleaned = cleaned.padStart(3, '0');
  const cents = cleaned.slice(-2);
  let integer = cleaned.slice(0, -2);
  integer = integer.replace(/^0+/, '') || '0';

  const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, config.thousandSeparator);
  
  return `${config.symbol} ${formattedInteger}${config.decimalSeparator}${cents}`;
};

export const formatPercent = (value) => {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(numValue)) return '';
  const config = getCurrencyConfig();
  const rounded = Math.round(numValue * 100) / 100;
  const str = rounded.toString();
  return str.replace('.', config.decimalSeparator);
};

export const parsePercent = (value) => {
  if (!value || value === '') return '';
  const config = getCurrencyConfig();
  const cleaned = value.toString().replace(config.decimalSeparator, '.').replace(/\s/g, '').trim();
  const parsed = parseFloat(cleaned);
  return isNaN(parsed) ? '' : parsed.toString();
};

export const handlePercentInputChange = (event, onChange) => {
  const inputValue = event.target.value;
  const config = getCurrencyConfig();
  const cleaned = inputValue.replace(/[^\d.,]/g, '');
  const parts = cleaned.split(/[.,]/);
  if (parts.length > 2) return;
  const validInteger = (parts[0] || '').replace(/\D/g, '');
  const validDecimal = (parts[1] || '').replace(/\D/g, '').slice(0, 2);
  const hasTrailingSeparator = /[.,]$/.test(cleaned);
  let formatted = validInteger;
  if (validDecimal || hasTrailingSeparator) {
    formatted += config.decimalSeparator + validDecimal;
  }
  const numericValue = formatted ? parseFloat(formatted.replace(config.decimalSeparator, '.')) : null;
  const syntheticEvent = {
    ...event,
    target: { ...event.target, value: formatted },
    numericValue: numericValue,
  };
  onChange(syntheticEvent);
};

export const handleCurrencyInputChange = (event, onChange) => {
  const inputValue = event.target.value;
  const config = getCurrencyConfig();
  
  let cleaned = inputValue.replace(/\D/g, '');
  
  if (cleaned === '') {
    onChange('');
    return;
  }
  
  cleaned = cleaned.padStart(3, '0');
  const cents = cleaned.slice(-2);
  let integer = cleaned.slice(0, -2);
  
  integer = integer.replace(/^0+/, '') || '0';
  
  const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, config.thousandSeparator);
  const formatted = `${config.symbol} ${formattedInteger}${config.decimalSeparator}${cents}`;
  
  const numericValue = parseFloat(cleaned) / 100;
  
  const syntheticEvent = {
    ...event,
    target: {
      ...event.target,
      value: formatted,
      numericValue: numericValue,
    },
  };
  
  onChange(syntheticEvent);
};
